import { render, staticRenderFns } from "./FaqCategoryList.vue?vue&type=template&id=3848a668&"
import script from "./FaqCategoryList.vue?vue&type=script&lang=js&"
export * from "./FaqCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports